// extracted by mini-css-extract-plugin
module.exports = {"container":"Mail_container__3N_SR","containerInner":"Mail_containerInner__3Do0F","padBottom":"Mail_padBottom__1xUVr","textArea":"Mail_textArea__1yVdq","dark":"Mail_dark__3bzz9"};